module.exports = __webpack_public_path__ + "static/media/rawhides.51dacff7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Products/sds/us/en/rawhides.pdf
// module id = 333
// module chunks = 0